import type { AppConfig } from '@/types';

export const appConfigData: AppConfig = {
  idleTimeout: 1800,
  color: '35 31 32',
  backgroundColor: '230 245 241',
};
